import React from 'react'
import { Link } from 'react-router-dom'

function SnapRoutes() {
  return (
    <>
      <Link to="/">Home</Link>
      <Link to="/about">About</Link>
      <Link to="/services">Services</Link>
      <Link to="/products">Products</Link>
      <Link to="/software-development-services">Software Development Services</Link>
      <Link to="/mobile-app-development-services">Mobile App Development Services</Link>
      <Link to="/web-development-services">Web Design & Development Services</Link>
      <Link to="/digital-marketing-services">Digital Marketing Services</Link>
      <Link to="/seo-services">SEO Services</Link>
      <Link to="/graphics-designing-services">Graphics Designing Services</Link>
      <Link to="/school-management-system">School Management System</Link>
      <Link to="/business-management-solutions">Business Management Solution</Link>
      <Link to="/ecommerce-solutions">Ecommerce Solutions</Link>
      <Link to="/restuarent-management-system">Point of Sale</Link>
      <Link to="/team">Team</Link>
      <Link to="/portfolio">Portfolio</Link>
      <Link to="/website-portfolio">Website Portfolio</Link>
      <Link to="/help">Knowledge Base</Link>
      <Link to="/industries">Industries</Link>
      <Link to="/faq-page">FAQs</Link>
      <Link to="/blog">Blogs</Link>
      <Link to="/contact">Contact</Link>
      <Link to="/user-login">User Login</Link>
    </>
  )
}

export default SnapRoutes
